import { render, staticRenderFns } from "./Loading.vue?vue&type=template&id=9873921e&scoped=true&"
var script = {}
import style0 from "./Loading.vue?vue&type=style&index=0&id=9873921e&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9873921e",
  null
  
)

export default component.exports